export default __webpack_public_path__ + "static/210602_夏日活動強更預告_en-91ea58e72a852c184a039d2a94dc0190.webp";